const AUTH_TOKEN_KEY = 'authToken'

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

export const setAuthToken = (value: string) => {
  localStorage.setItem(AUTH_TOKEN_KEY, value)
}
